export default __webpack_public_path__ + "static/media/Eytan_sq.e7b33fce.jpeg";